import React from 'react';
import { styled } from '@mui/material/styles';
import { Modal, Card, CardHeader, CardContent, Stack, IconButton, Button, Typography, TextField, Tooltip } from '@mui/material';
import { useResponsive } from '../../../services/hooks';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const iconButtonStyle = {
  border: '1px solid #dce0e4',
  borderRadius: '0 8px 8px 0',
  borderLeft: 'none'
};

const CustomTextField = styled(TextField)(() => ({
  '& fieldset': {
    borderRadius: '8px 0 0 8px'
  }
}));

const BankTransferDetailsModal = ({ number, title, amount, open, handleClose }) => {
  const isDesktop = useResponsive('up', 'lg');
  const [copied, setCopied] = React.useState(false);

  const handleCopy = type => {

    const text = type === 'number' ? number : type === 'title' ? title : amount;

    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
    });
  };

  return (<Modal
    open={open}
    onClose={handleClose}
  >
    <Card sx={{ ...style, width: isDesktop ? '400px' : '95vw' }}>
      <CardHeader title="Dane do przelewu"/>
      <CardContent>
        <Stack spacing={4}>
          <Stack direction="row">
            <CustomTextField
              label="Odbiorca"
              defaultValue={'KLUB JU-JITSU MOHIKAN Łukasz Ławrynowicz'}
              fullWidth
              InputProps={{
                readOnly: true
              }}
              sx={{ borderRadius: '0' }}
            />
            <Tooltip title={copied ? 'Skopiowano!' : 'Kopiuj'} placement="right">
              <IconButton style={{ ...iconButtonStyle }} onClick={() => handleCopy('title')} onMouseLeave={() => setCopied(false)}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Stack direction="row">
            <CustomTextField
              label="Numer konta (BNP Paribas Bank Polska SA.)"
              defaultValue={number}
              fullWidth
              InputProps={{
                readOnly: true
              }}
              sx={{ borderRadius: '0' }}
            />
            <Tooltip title={copied ? 'Skopiowano!' : 'Kopiuj'} placement="right">
              <IconButton style={{ ...iconButtonStyle }} onClick={() => handleCopy('number')} onMouseLeave={() => setCopied(false)}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Stack direction="row">
            <CustomTextField
              label="Tytuł płatności"
              defaultValue={title}
              fullWidth
              InputProps={{
                readOnly: true
              }}
              sx={{ borderRadius: '0' }}
            />
            <Tooltip title={copied ? 'Skopiowano!' : 'Kopiuj'} placement="right">
              <IconButton style={{ ...iconButtonStyle }} onClick={() => handleCopy('title')} onMouseLeave={() => setCopied(false)}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Stack direction="row">
            <CustomTextField
              label="Kowta (zł)"
              defaultValue={amount}
              fullWidth
              InputProps={{
                readOnly: true
              }}
              sx={{ borderRadius: '0' }}
            />
            <Tooltip title={copied ? 'Skopiowano!' : 'Kopiuj'} placement="right">
              <IconButton style={{ ...iconButtonStyle }} onClick={() => handleCopy('amount')} onMouseLeave={() => setCopied(false)}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
          </Stack>
          <Button variant="contained" onClick={handleClose}>Zamknij</Button>
        </Stack>
      </CardContent>
    </Card>
  </Modal>);
};

export default BankTransferDetailsModal;
